import { render, staticRenderFns } from "./LichSuTourDuLichForm.vue?vue&type=template&id=519ad16c"
import script from "./LichSuTourDuLichForm.vue?vue&type=script&lang=js"
export * from "./LichSuTourDuLichForm.vue?vue&type=script&lang=js"
import style0 from "./LichSuTourDuLichForm.vue?vue&type=style&index=0&id=519ad16c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports